import { logoutUser } from "@/store/reducers/userSlice";
import { AxiosError } from "axios";
import { BACKEND_CONFIG } from "./backend";
import toast from "react-hot-toast";
import type { InternalAxiosRequestConfig } from "axios";
import { getActiveMunicipalityId } from "./activeMunicipality";

export const authRequestInterceptor = (config: InternalAxiosRequestConfig) => {
  const municipalityId = getActiveMunicipalityId();
  if (municipalityId && config.headers.get('x-active-municipality-id') == null) {
    // Imports explicitly pin the municipality reviewed by the user. A global
    // municipality switch must not retarget an already prepared request.
    config.headers.set('x-active-municipality-id', municipalityId);
  }
  return config;
};

export const authResponseInterceptor = async (error: AxiosError) => {
  const responseData = error?.response?.data as { error?: string } | undefined;
  if (
    error?.config?.baseURL === BACKEND_CONFIG.baseURL &&
    error?.response?.status === 401 &&
    responseData?.error !== 'EMAIL_NOT_VERIFIED'
  ) {
    const store = (await import("@/store")).default;
    const userState = store.getState().user;

    if (userState.isLoggedIn && !userState.loading) {
      try {
        await store.dispatch(logoutUser()).unwrap();
      } catch (errorMessage: unknown) {
        const msg = errorMessage instanceof Error ? errorMessage.message : "Odhlášení selhalo";
        toast.error(msg);
      }
    }
  }
  return Promise.reject(error);
};
